import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"font-size":"1.3em"},
  class: "p-grid p-text-uppercase"
}
const _hoisted_2 = { class: "p-col-12 p-md-6 p-xl-4" }
const _hoisted_3 = { class: "p-col-12 p-md-6 p-xl-4" }
const _hoisted_4 = { class: "p-col-12 p-md-6 p-xl-4" }
const _hoisted_5 = { class: "p-grid card p-mt-4 p-mx-1" }
const _hoisted_6 = { class: "p-col-12 p-md-6" }
const _hoisted_7 = { class: "p-col-12 p-md-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", null, "Revenu mensuel de l'année", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!
  const _component_CurrentRevenueBySubscription = _resolveComponent("CurrentRevenueBySubscription")!
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Alert, {
          icon: _ctx.featureIcons.user,
          title: _ctx.$t('workspaceLayout.user'),
          number: 1,
          value1: _ctx.overviews.usersCount
        }, null, 8, ["icon", "title", "value1"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Alert, {
          icon: _ctx.featureIcons.activity,
          title: _ctx.$t('workspaceLayout.activity'),
          number: 2,
          value1: _ctx.overviews.activitiesCount
        }, null, 8, ["icon", "title", "value1"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Alert, {
          icon: _ctx.featureIcons.pos,
          title: _ctx.$t('ticket.revenue'),
          number: 4,
          value1: _ctx.overviews.subscriptionPaymentTotalAmount
        }, null, 8, ["icon", "title", "value1"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_CurrentRevenueBySubscription)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_Chart, {
          type: "bar",
          options: _ctx.options,
          data: _ctx.chartData
        }, null, 8, ["options", "data"])
      ])
    ])
  ], 64))
}